<template>
  <div class="pop-tel">
    <div class="pop-tel-main">
      <div class="pop-tel-list">
        <a
          v-for="tel in telContact"
          :key="tel.label"
          class="pop-tel-item"
          :href="`tel:${tel.value}`"
          @click="handlClose"
        >
          {{ tel.label }}
        </a>
      </div>

      <div class="btns">
        <button
          class="btn-cancel"
          @click="handlClose"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    telContact: {
      type: [Array],
      default: null
    }
  },
  methods: {
    handlClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-tel {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 85%);
}

.pop-tel-main {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: 750px;
  transform: translateX(-50%);

  .pop-tel-list,
  .btns {
    border-radius: 14px;
    margin: 8px 10px;
    background: #f8f8f8;
  }

  .pop-tel-item,
  .btn-cancel {
    display: block;
    width: 100%;
    height: 56px;
    color: #007aff;
    font-size: 20px;
    font-weight: 400;
    line-height: 56px;
    text-align: center;
  }

  .pop-tel-item:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 20%);
  }
}

</style>
